import { render, staticRenderFns } from "./InventoryValuation.vue?vue&type=template&id=3a21bc8e"
import script from "./InventoryValuation.vue?vue&type=script&lang=js"
export * from "./InventoryValuation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports